"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogTitleBody = exports.DialogTitle = void 0;
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var styles_1 = require("@material-ui/core/styles");
exports.DialogTitle = styles_1.styled(DialogTitle_1.default)({
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
}, { name: "EuiDialogTitle" });
exports.DialogTitleBody = styles_1.styled("div")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        flexGrow: 1,
        padding: "0.125rem 0",
        "&:not(:last-child)": {
            marginRight: spacing(4),
        },
    });
}, { name: "EuiDialogTitleBody" });
//# sourceMappingURL=DialogLayoutBase.js.map